import { calculatePeriod } from 'core/service/basic-plan'
import { queryPremiumRateForWPTPDCI as queryPremiumRate } from 'core/service/rider/query-premium-rate'
import { calculateRiderPremiumForWPTPDCI as calculateRiderPremium } from 'core/service/rider/premium-calculation'

const getYearsOfCoverage = (coveragePeriod, age, basicPaymentPeriod, basicPlanCoveragePeriod, paymentPeriod) => {
  const _basicPaymentPeriod = Object.assign({}, basicPaymentPeriod)
  if (paymentPeriod) {
    _basicPaymentPeriod.value = paymentPeriod
  }
  const ageValue = age.unit !== 'year' ? 0 : age.value
  const yearsOfCoverage = Math.min(coveragePeriod - ageValue, calculatePeriod(_basicPaymentPeriod, ageValue))
  return yearsOfCoverage > basicPlanCoveragePeriod ? basicPlanCoveragePeriod : yearsOfCoverage
}

export default {
  calculateRiderPremium,
  queryPremiumRate,
  getYearsOfCoverage,
}
